import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const api = {
  me: () => client.get("/auth/me").then(r => r.data),
  session: (session_id) => client.post("/auth/session", { session_id }).then(r => r.data),
  logout: () => client.post("/auth/logout").then(r => r.data),
  setRole: (role) => client.post("/auth/role", { role }).then(r => r.data),

  listProjects: () => client.get("/projects").then(r => r.data),
  getProject: (id) => client.get(`/projects/${id}`).then(r => r.data),
  createProject: (b) => client.post("/projects", b).then(r => r.data),
  updateProject: (id, b) => client.patch(`/projects/${id}`, b).then(r => r.data),
  deleteProject: (id) => client.delete(`/projects/${id}`).then(r => r.data),

  listLeads: () => client.get("/leads").then(r => r.data),
  createLead: (b) => client.post("/leads", b).then(r => r.data),
  getLead: (id) => client.get(`/leads/${id}`).then(r => r.data),
  updateLead: (id, b) => client.patch(`/leads/${id}`, b).then(r => r.data),
  deleteLead: (id) => client.delete(`/leads/${id}`).then(r => r.data),
  triageLead: (id) => client.post(`/leads/${id}/triage`).then(r => r.data),
  listLeadMessages: (id) => client.get(`/leads/${id}/messages`).then(r => r.data),
  sendLeadMessage: (id, body) => client.post(`/leads/${id}/messages`, { body }).then(r => r.data),

  listTalent: () => client.get("/talent").then(r => r.data),
  createTalent: (b) => client.post("/talent", b).then(r => r.data),
  deleteTalent: (id) => client.delete(`/talent/${id}`).then(r => r.data),

  analytics: () => client.get("/analytics/overview").then(r => r.data),
  ai: (kind, context) => client.post("/ai/generate", { kind, context }).then(r => r.data),

  // INDIEWOOD — Streamer Workstation
  createContent: (b) => client.post("/content", b).then(r => r.data),
  uploadImage: (file) => { const fd = new FormData(); fd.append("file", file); return client.post("/uploads", fd).then(r => r.data); },
  myContent: () => client.get("/content/mine").then(r => r.data),
  updateContent: (id, b) => client.patch(`/content/${id}`, b).then(r => r.data),
  deleteContent: (id) => client.delete(`/content/${id}`).then(r => r.data),
  contentAnalytics: (id) => client.get(`/content/${id}/analytics`).then(r => r.data),
  uploadVideoChunk: (uploadId, index, blob) => {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", index);
    fd.append("file", blob, "chunk");
    return client.post("/videos/upload/chunk", fd).then(r => r.data);
  },
  completeVideoUpload: (uploadId, filename, contentId) => {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("filename", filename);
    fd.append("content_id", contentId);
    return client.post("/videos/upload/complete", fd).then(r => r.data);
  },

  // INDIEWOOD — Viewers Dashboard
  watchFeed: (q = "", genre = "") => client.get("/watch/feed", { params: { q, genre } }).then(r => r.data),
  watchChannels: () => client.get("/watch/channels").then(r => r.data),
  watchContent: (id) => client.get(`/watch/content/${id}`).then(r => r.data),
  bumpView: (id) => client.post(`/content/${id}/view`).then(r => r.data),
  rateContent: (id, stars) => client.post(`/content/${id}/rate`, { stars }).then(r => r.data),
  listReviews: (id) => client.get(`/content/${id}/reviews`).then(r => r.data),
  addReview: (id, body, reaction = "") => client.post(`/content/${id}/reviews`, { body, reaction }).then(r => r.data),
  listNotes: (id) => client.get(`/content/${id}/notes`).then(r => r.data),
  addNote: (id, timestamp, body) => client.post(`/content/${id}/notes`, { timestamp, body }).then(r => r.data),
  listChat: (id) => client.get(`/content/${id}/chat`).then(r => r.data),
  postChat: (id, body) => client.post(`/content/${id}/chat`, { body }).then(r => r.data),
  screeningRequest: (id, payload) => client.post(`/content/${id}/screening-request`, payload).then(r => r.data),
  purchaseContent: (id, kind, origin_url) => client.post(`/content/${id}/purchase`, { kind, origin_url }).then(r => r.data),
  boxOfficeStatus: (sid) => client.get(`/box-office/status/${sid}`).then(r => r.data),

  // INDIEWOOD — Networking Circuit
  netProfiles: (params = {}) => client.get("/network/profiles", { params }).then(r => r.data),
  myNetProfiles: () => client.get("/network/profiles/me").then(r => r.data),
  saveNetProfile: (b) => client.post("/network/profiles", b).then(r => r.data),
  deleteNetProfile: (id) => client.delete(`/network/profiles/${id}`).then(r => r.data),
  netPosts: (side = "", q = "") => client.get("/network/posts", { params: { side, q } }).then(r => r.data),
  createNetPost: (b) => client.post("/network/posts", b).then(r => r.data),
  deleteNetPost: (id) => client.delete(`/network/posts/${id}`).then(r => r.data),
  rentals: (type = "", q = "") => client.get("/network/rentals", { params: { type, q } }).then(r => r.data),
  createRental: (b) => client.post("/network/rentals", b).then(r => r.data),
  deleteRental: (id) => client.delete(`/network/rentals/${id}`).then(r => r.data),

  // INDIEWOOD — ERP & Studio Tools
  generateImage: (prompt, kind) => client.post("/tools/generate-image", { prompt, kind }).then(r => r.data),
  genImages: () => client.get("/tools/gen-images").then(r => r.data),
  budgets: () => client.get("/tools/budgets").then(r => r.data),
  createBudget: (b) => client.post("/tools/budgets", b).then(r => r.data),
  deleteBudget: (id) => client.delete(`/tools/budgets/${id}`).then(r => r.data),
  invoices: () => client.get("/tools/invoices").then(r => r.data),
  createInvoice: (b) => client.post("/tools/invoices", b).then(r => r.data),
  updateInvoice: (id, b) => client.patch(`/tools/invoices/${id}`, b).then(r => r.data),
  deleteInvoice: (id) => client.delete(`/tools/invoices/${id}`).then(r => r.data),
  prodTasks: () => client.get("/tools/prod-tasks").then(r => r.data),
  createProdTask: (b) => client.post("/tools/prod-tasks", b).then(r => r.data),
  toggleProdTask: (id) => client.patch(`/tools/prod-tasks/${id}`).then(r => r.data),
  deleteProdTask: (id) => client.delete(`/tools/prod-tasks/${id}`).then(r => r.data),

  // INDIEWOOD — mode, billing, social, playlists, settings
  setMode: (mode) => client.patch("/me/profile", { mode }).then(r => r.data),
  billingPlans: () => client.get("/billing/plans").then(r => r.data),
  billingCheckout: (plan, origin_url) => client.post("/billing/checkout", { plan, origin_url }).then(r => r.data),
  billingStatus: (sid) => client.get(`/billing/status/${sid}`).then(r => r.data),
  subscribeContent: (id) => client.post(`/content/${id}/subscribe`).then(r => r.data),
  recommendContent: (id) => client.post(`/content/${id}/recommend`).then(r => r.data),
  referContent: (id) => client.post(`/content/${id}/refer`).then(r => r.data),
  topSelling: () => client.get("/watch/top-selling").then(r => r.data),
  playlists: () => client.get("/playlists").then(r => r.data),
  createPlaylist: (b) => client.post("/playlists", b).then(r => r.data),
  deletePlaylist: (id) => client.delete(`/playlists/${id}`).then(r => r.data),
  screeningRequestsReceived: () => client.get("/content/screening-requests").then(r => r.data),
  netSettings: () => client.get("/network/settings").then(r => r.data),
  updateNetSettings: (b) => client.patch("/network/settings", b).then(r => r.data),
  toolsSettings: () => client.get("/tools/settings").then(r => r.data),
  updateToolsSettings: (b) => client.patch("/tools/settings", b).then(r => r.data),
  toolsTrash: () => client.get("/tools/trash").then(r => r.data),

  // INDIEWOOD — directory, watch extras, feedback, voting, live, flag
  directory: (q = "", category = "") => client.get("/directory", { params: { q, category } }).then(r => r.data),
  watchArtists: () => client.get("/watch/artists").then(r => r.data),
  watchTrending: () => client.get("/watch/trending").then(r => r.data),
  submitFeedback: (b) => client.post("/feedback", b).then(r => r.data),
  liveStats: () => client.get("/live").then(r => r.data),
  castVote: (vote) => client.post("/vote", { vote }).then(r => r.data),
  flagContent: (id, b) => client.post(`/content/${id}/flag`, b).then(r => r.data),
  report: (b) => client.post("/report", b).then(r => r.data),
  updateProfile: (b) => client.patch("/me/profile", b).then(r => r.data),

  seed: () => client.post("/seed").then(r => r.data),
};

export default client;
